import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=cb8ef884&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=cb8ef884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8ef884",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb8ef884')) {
      api.createRecord('cb8ef884', component.options)
    } else {
      api.reload('cb8ef884', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=cb8ef884&scoped=true&", function () {
      api.rerender('cb8ef884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8MyGEUGugyupz/JS/comp/CookieBox.vue"
export default component.exports